import type { DeliveryPoint } from '@/lib/api/delivery';

export function deliveryTimeLabel(value: unknown): string {
  const text = String(value ?? '').trim();
  if (!text) return 'Уточняется';
  return /^[\d\s.,–—-]+$/.test(text) ? `${text} мин` : text;
}

export function deliveryMoney(value: unknown): string {
  if (value === undefined || value === null || !Number.isFinite(Number(value))) return 'Уточняется';
  return `${new Intl.NumberFormat('ru-RU').format(Number(value))} ₽`;
}

export interface DeliveryTariff {
  key: string;
  cost: number;
  minimum: number;
  time: string;
  zoneIds: number[];
}

export function deliveryTariffs(points: DeliveryPoint[]): DeliveryTariff[] {
  const tariffs = new Map<string, DeliveryTariff>();
  for (const point of points) {
    if (point.is_active === false) continue;
    for (const zone of point.zones ?? []) {
      if (zone.delivery_cost == null || zone.min_order_sum == null) continue;
      const cost = Number(zone.delivery_cost);
      const minimum = Number(zone.min_order_sum);
      if (!Number.isFinite(cost) || !Number.isFinite(minimum) || cost < 0 || minimum < 0) continue;
      const time = deliveryTimeLabel(zone.estimated_time);
      const key = `${cost}/${minimum}/${time}`;
      const tariff = tariffs.get(key) ?? { key, cost, minimum, time, zoneIds: [] };
      if (!tariff.zoneIds.includes(zone.id)) tariff.zoneIds.push(zone.id);
      tariffs.set(key, tariff);
    }
  }
  return [...tariffs.values()].sort(
    (a, b) =>
      a.cost - b.cost ||
      a.minimum - b.minimum ||
      a.time.localeCompare(b.time, 'ru', { numeric: true })
  );
}
